/**
 * When an order is wanted.
 *
 * The shop schedules on the hour and the half — never 4:07 — so the time is
 * chosen from a fixed list rather than typed into a minute wheel. Kept here
 * with the other domain rules so the slots and the defaults can be checked
 * without standing up a screen.
 */
/** Every half hour of the day, as 24-hour `HH:MM`. */
export const TIME_SLOTS = Array.from({ length: 48 }, (_, index) => {
    const hour = Math.floor(index / 2);
    return `${String(hour).padStart(2, '0')}:${index % 2 === 0 ? '00' : '30'}`;
});
/**
 * `16:00` → `4:00 PM`, because that is how the counter says it.
 *
 * Midnight and noon are the ones to watch: both are hour 12 on a clock face,
 * and naive arithmetic renders them "0:00 AM" and "0:00 PM".
 */
export function slotLabel(slot) {
    const hour = Number(slot.slice(0, 2));
    const minute = slot.slice(3);
    const suffix = hour < 12 ? 'AM' : 'PM';
    const twelve = hour % 12 === 0 ? 12 : hour % 12;
    return `${twelve}:${minute} ${suffix}`;
}
/**
 * What each kind of order is wanted by, when nobody says otherwise.
 *
 * Pickups land in the late afternoon, deliveries an hour later — the shop's
 * own habit, not a guess. Editable on every order; this only decides what is
 * already filled in.
 */
export const DEFAULT_DUE_TIME = {
    pickup: '16:00',
    delivery: '17:00',
};
/** Today on the shop's own calendar rather than UTC's, as `YYYY-MM-DD`. */
export function todayLocal(now = new Date()) {
    return [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
    ].join('-');
}
//# sourceMappingURL=scheduling.js.map